__turbopack_context__.v({
  "disabled": "NQu2va_disabled",
  "icon": "NQu2va_icon",
  "moveButton": "NQu2va_moveButton",
});
